import { useState } from 'react';
import { Dialog, DialogContent, DialogTitle } from './ui/dialog';

const src = (id, w, h) => `https://a.espncdn.com/combiner/i?img=/i/headshots/nba/players/full/${id}.png&w=${w}&h=${h}&cb=1`;

// ESPN headshot with a jersey-number badge (NBA player legs). Tap it to see the face big.
export const Headshot = ({ leg, size = 28, testId, badge = true }) => {
  const [bad, setBad] = useState(false);
  const [open, setOpen] = useState(false);
  const id = leg.athlete_id || leg.player_id;
  if ((leg.league || '').toLowerCase() !== 'nba' || !id || bad) return null;
  const name = leg.player_name || leg.name;
  return (
    <>
      <button type="button" className="relative inline-block shrink-0 cursor-zoom-in rounded-full transition-transform active:scale-95" style={{ width: size, height: size }}
        data-testid={testId} aria-label={`See ${name || 'player'} bigger`}
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}>
        <img src={src(id, 96, 70)} alt="" onError={() => setBad(true)} loading="lazy"
          className="h-full w-full rounded-full border border-white/20 bg-zinc-800 object-cover object-top" />
        {badge && leg.jersey && (
          <span className="absolute -bottom-1 -right-1.5 rounded-full bg-black/90 px-1 text-[8px] font-black leading-[12px] text-white ring-1 ring-white/30">#{leg.jersey}</span>
        )}
      </button>
      {open && (
        <Dialog open onOpenChange={(o) => !o && setOpen(false)}>
          <DialogContent className="max-w-xs border-zinc-800 bg-zinc-950 p-4 text-white" data-testid="headshot-zoom" onClick={(e) => e.stopPropagation()}>
            <DialogTitle className="text-center text-base">{name}{leg.jersey ? ` · #${leg.jersey}` : ''}</DialogTitle>
            <div className="relative mx-auto aspect-[4/3] w-full overflow-hidden rounded-xl bg-gradient-to-b from-zinc-800 to-zinc-900">
              <img src={src(id, 600, 436)} alt={name || ''} className="h-full w-full object-contain object-bottom" data-testid="headshot-zoom-img" />
              {leg.team_logo && <img src={leg.team_logo} alt="" className="absolute left-2 top-2 h-8 w-8 object-contain" />}
            </div>
            {leg.player_team && <p className="text-center text-xs text-zinc-400">{leg.player_team}</p>}
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};
